import React, { Component, lazy, Suspense } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Loader from './components/Loader';
import Route404 from './components/Route404';

const Home = lazy(() => import('./containers/Home'));
const Archive = lazy(() => import('./containers/Home/archive'));
const Contract = lazy(() => import('./containers/Contract'));
const Person = lazy(() => import('./containers/Person'));
const Claim = lazy(() => import('./containers/Claim'));
const Passwd = lazy(() => import('./containers/Passwd'));
const Extended = lazy(() => import('./containers/Extended'));
const Petitions = lazy(() => import('./containers/Petitions'));

class Main extends Component {
  // eslint-disable-line
  render() {
    const { defaultPassword, location } = this.props;
    if (defaultPassword && location.pathname !== '/passwd') {
      return <Redirect to='/passwd' />;
    }
    return (
      <Suspense fallback={<Loader />}>
        <DndProvider backend={HTML5Backend}>
          <Switch>
            <Route exact path='/' render={props => <Home {...props} />} />
            <Route exact path='/contract/' render={props => <Home {...props} />} />
            <Route exact path='/contract/:code' render={props => <Contract {...props} />} />
            <Route exact path='/archive/' render={props => <Archive {...props} />} />
            <Route exact path='/archive/:code' render={props => <Contract {...props} />} />
            <Route exact path='/me' render={props => <Person {...props} />} />
            <Route path='/petitions' render={props => <Petitions {...props} />} />
            <Route exact path='/claim' render={props => <Claim {...props} />} />
            <Route exact path='/passwd' render={props => <Passwd {...props} />} />
            <Route exact path='/extended' render={props => <Extended {...props} />} />
            <Route exact path='/extendedlkk' render={props => <Extended {...props} />} />
            <Route component={Route404} />
          </Switch>
        </DndProvider>
      </Suspense>
    );
  }
}

export default withRouter(Main);
